export const NAME = 'mymessages';

/**
 * Here goes the actionTypes
 */
export const REQUEST_ACCOUNT_MESSAGES = 'REQUEST_ACCOUNT_MESSAGES';
export const RECEIVE_ACCOUNT_MESSAGES = 'RECEIVE_ACCOUNT_MESSAGES';
export const FAILURE_ACCOUNT_MESSAGES = 'FAILURE_ACCOUNT_MESSAGES';



// WEBPACK FOOTER //
// ./src/services/account/mymessages/constants.js